import { render } from "./popupBase.vue?vue&type=template&id=77144c4e&scoped=true"
import script from "./popupBase.vue?vue&type=script&lang=js"
export * from "./popupBase.vue?vue&type=script&lang=js"

import "./popupBase.vue?vue&type=style&index=0&id=77144c4e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77144c4e"]])

export default __exports__